<template>
  <div>
    <p class="small text-muted mb-3">{{ $t('AiHome.ocr.edit_hint') }}</p>

    <textarea
      v-model="text"
      spellcheck="true"
      class="form-control mb-3"
      style="height: 16rem; resize: none;"
    ></textarea>

    <p class="small text-muted text-center mb-3">
      {{ $t('AiHome.ocr.recognition_warning_hint') }}
    </p>

    <div class="mt-4 d-flex justify-content-end">
      <button @click="$emit('toStepNum', 1)" class="btn btn-outline-secondary mr-2 py-2 px-4">{{ $t('AiHome.ocr.btn_reupload') }}</button>
      <button @click="finish()" class="btn btn-primary bg-blue-main py-2 px-4">{{ $t('AiHome.ocr.btn_input_submit') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recognizedText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      text: this.recognizedText
    }
  },
  watch: {
    recognizedText (newVal) {
      this.text = newVal
    }
  },
  methods: {
    finish () {
      this.$emit('finish', this.text)
    }
  }
}
</script>

  <style scoped>
  .bg-brown {
    background-color: #8c5a42;
  }
</style>
